/*
 * @Author: Alexander.Vangelov@vonage.com 
 * @Date: 2024-03-18 13:30:17 
 * @Last Modified by:   Alexander.Vangelov@vonage.com 
 * @Last Modified time: 2024-03-18 13:30:17 
 */

import { share } from './share';
const dialPrompt = require('./dialPrompt');


(window as any).scContentHooks = (window as any).scContentHooks || [];

function onClick(ev) {
  function guDialMsg(callback) {
    var msg: any = {
      action: 'guScDial',
      data: dialNumber
    };
    if ((window as any).scContentHooks.length > 0) {
      var attachments: Array<any> = [];
      (window as any).scContentHooks.forEach(function(hookCallback) {
        try {
          var extraInfo = hookCallback(ev.target.parentNode);
          if (extraInfo) attachments.push(extraInfo);
        } catch(err) {}
      });
      if (attachments.length > 0) msg.attachments = attachments;
    }
    callback(msg);
  }
  if (ev.target.tagName === 'VG-IS-IMG' && ev.target.parentNode.tagName === 'VG-IS-DIAL') {
    var dialNumber = ev.target.parentNode.getAttribute('data-dn');
    if (dialNumber) {
      guDialMsg(function(msg) {
        dialPrompt(msg, function(nMsg) {
          if (nMsg.action === 'guScDial') {
            const placeCallFunction = ((window as any).VonageDialer || share.share || share).placeCall;
            if (typeof(placeCallFunction) === 'function') {
              placeCallFunction(msg.data);
            } else {
              console.error('VonageDialer is not ready! (Call init first).');
            }
          } else if (nMsg.action === 'guScSms') {
            const sendSmsFunction = ((window as any).VonageDialer || share.share || share).sendSms;
            if (typeof(sendSmsFunction) === 'function') {
              try {
                const vgisButton = document.querySelector('button.vgip-button') as HTMLButtonElement;
                if (vgisButton) {
                  vgisButton.click();
                }
              } catch(e) {}
              sendSmsFunction(msg.data);
            } else {
              console.error('VonageDialer is not ready! (Call init first).');
            }
          }
        });
      });
      ev.preventDefault();
      ev.stopPropagation();
      return false;
    }
  }
}

module.exports = {
  onClick: onClick
};